<template>
  <v-card>
    <v-card-title>
      <div>
        <div class="headline">Standard Risk Text</div>
      </div>
      <v-spacer></v-spacer>
      <v-flex xs6>
        <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
      </v-flex>
    </v-card-title>
    <v-flex xs12>
      <message :messages="messages"></message>
    </v-flex>
    <v-data-table v-bind:headers="headers" v-bind:items="items" v-bind:search="search" :rows-per-page-items="itemsPerPage" v-bind:pagination.sync="pagination" item-key="name" :loading="loading" :no-data-text="noDataText" :filter="customSearch">
      <template slot="headerCell" slot-scope="props">
        <v-tooltip bottom>
          <span slot="activator">
            {{ props.header.text }}
          </span>
          <span>
            {{ props.header.text }}
          </span>
        </v-tooltip>
      </template>
      <template slot="items" slot-scope="props">
        <td class="text-xs-left">{{ props.item.riskNo }}</td>
        <td class="text-xs-left">{{ props.item.stdRiskTxt }} - {{ formatTextLength(props.item.stdRiskTxtDesc) }} </td>
        <td class="text-xs-right">
          <table-action :rowData="props" review @review="doReview" remove @remove="doPromptRemove(props.item)"></table-action>
        </td>
      </template>
    </v-data-table>
    <v-btn color="primary" dark class="mb-2" @click.native="doNew()" v-if="riskList.length > 0">New Standard Risk Text<v-icon>mdi-plus</v-icon></v-btn>
    <confirm v-model="promptRemove" @ok="doRemove">
      Are you sure that you want to delete the selected Permitted Standard Risk Text?
      <div class="title">{{deleteText}}</div>
    </confirm>
  </v-card>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { expandURI } from '@/utils/ajax'
import MessageMixin from '@/mixins/message'
import FieldMixin from '@/mixins/field'
export default {
  data() {
    return {
      headers: [
        { text: 'Risk No', value: 'riskNo' },
        { text: 'Standard Risk Text', value: 'stdRiskTextRef' },
        TableConst.tableActionHeader
      ],
      deleteText: '',
      promptRemove: false,
      riskList: []
    }
  },
  computed: {
    schemeMenu() {
      return this.$store.state.parameters.scheme.schemeMenu
    }
  },
  watch: {
    'fetchRisk': function (value) {
      if (value !== false) {
        this.doInit()
      }
    }
  },
  methods: {
    async doInit() {
      await this.fetchData(this.scheme)
    },
    async fetchData(xscheme) {
      if (this.schemeMenu.init !== 1) {
        await this.$store.dispatch('schemeMenuInit', xscheme)
      }
      const apiURI = this.schemeMenu.menu.pkgStdRiskTxts
      if (apiURI) {
        await this.doRiskList(xscheme)
        try {
          const expand = {
            scheme: xscheme
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.items = []
            data.map((stdRiskTxt) => {
              const convertList = {
                riskNo: stdRiskTxt.riskNo,
                stdRiskTxt: stdRiskTxt.stdRiskTxt,
                stdRiskTxtDesc: stdRiskTxt.stdRiskTxtDesc
              }
              this.items.push(convertList)
            })
            this.loading = false
          } else {
            this.items = []
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.errorMessage('Invalid API Url - Standard Risk Text List')
      }
    },
    async doRiskList(xscheme) {
      this.resetMessages()
      const apiURI = this.schemeMenu.menu.riskList
      if (apiURI) {
        try {
          const expand = {
            scheme: xscheme
          }
          this.riskLoading = true
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.riskList = data.riskList
          } else {
            this.riskList = []
            this.message(result.data)
          }
          this.riskLoading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.errorMessage('Invalid API URL - Risk List')
      }
    },
    doReview(data) {
      this.$emit('doReview', data.item)
    },
    doNew() {
      this.$emit('doNew')
    },
    doPromptRemove(data) {
      if (data) {
        this.promptRemove = true
        this.selectedText = data
        this.deleteText = data.riskNo + ' - ' + data.stdRiskTxt
      }
    },
    async doRemove() {
      const apiURI = this.schemeMenu.menu.pkgStdRiskTxtDelete
      if (apiURI) {
        this.loading = true
        const expand = {
          scheme: this.scheme,
          planNo: this.selectedText.planNo,
          riskNo: this.selectedText.riskNo,
          stdRiskTxt: this.selectedText.stdRiskTxt
        }
        try {
          const result = await this.$http.post(apiURI, expand)
          this.notify(result.data)
          // Reinit
          this.loading = false
          this.doInit()
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.$snotify.error('Invalid API URL - Delete Text')
      }
    }
  },
  mounted() {
    Promise.all([this.doInit()])
  },
  props: {
    fetchRisk: {
      type: Boolean,
      default: false
    },
    scheme: {
      type: String,
      default: ''
    }
  },
  mixins: [
    TableConst.default,
    MessageMixin,
    FieldMixin
  ]
}
</script>

<style>

</style>
